import type { SyncTransport } from '@/app/ports';
import type { Operation, OperationResult, PullPage } from '@/sync/ops';
import { PROTOCOL_VERSION } from '@/sync/ops';
import { api } from './client';

export const httpSyncTransport: SyncTransport = {
  async push(workspaceId: string, deviceId: string, ops: Operation[]): Promise<OperationResult[]> {
    const r = await api<{ results: OperationResult[] }>('POST', '/sync/push', { protocol_version: PROTOCOL_VERSION, device_id: deviceId, workspace_id: workspaceId, operations: ops });
    return r.results;
  },
  async pull(workspaceId: string, cursor: string | null, limit: number, projectId?: string): Promise<PullPage> {
    const q = new URLSearchParams({ workspace_id: workspaceId, limit: String(limit) });
    if (projectId) q.set('project_id', projectId);
    if (cursor) q.set('cursor', cursor);
    q.set('capabilities', 'activity,file'); // optional feed types this client understands (protocol negotiation)
    return api<PullPage>('GET', '/sync/pull?' + q.toString());
  },
};
